module.exports = __webpack_public_path__ + "579f556c291db2a8b32819f94a9f3204.woff";